import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=d5edbf28&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=d5edbf28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5edbf28",
  null
  
)

export default component.exports